import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {TrademarkPO} from "@/model/product";
import {WriteTrademarkForm} from "@/pages/Trademark/WriteTrademark";
import {PaybackPO} from "@/model/finance";
import {ContractPO} from "@/model/customer";

export enum TrademarkEnum {
    GetTrademarkPage = "/trademark/getTrademarkPage",
    GetTrademark = "/trademark/getTrademark",
    CreateTrademark = "/trademark/createTrademark",
    UpdateTrademark = "/trademark/updateTrademark",
}

export interface TrademarkPageBO extends PaginationBO {
    keyword?: string;
}

export interface TrademarkPageVO extends ReviewStatusVO, TrademarkPO {
    instanceId: number
}

export interface TrademarkVO extends TrademarkPO {
    paybacks: PaybackPO[];
    contract: ContractPO
    contact: string
    mobile: string;
}

export interface ReceiveTrademarkBO {
    instanceId: number;
    businessId: number;
    executeId: string;
}

export const useQueryTrademarkPage = (writeStatus: number) => useMutation({
    mutationFn: (data: TrademarkPageBO) => http.post<BaseVO<PaginationVO<TrademarkPageVO>>>({
        url: TrademarkEnum.GetTrademarkPage,
        data: {...data, writeStatus: writeStatus},
    }),
})

export const useCreateTrademark = () => useMutation({
    mutationFn: (data: WriteTrademarkForm) => http.put<BaseVO<null>>({
        url: TrademarkEnum.CreateTrademark,
        data
    }),
})

export const useUpdateTrademark = () => useMutation({
    mutationFn: (data: WriteTrademarkForm) => http.post<BaseVO<null>>({
        url: TrademarkEnum.UpdateTrademark,
        data
    }),
})

export const useQueryTrademark = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<TrademarkVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<TrademarkVO>>({
        url: TrademarkEnum.GetTrademark,
        params: params
    }),
    enabled
})


